import React from "react";

function CardWrapper(props) {
  const divStyle = props.style || {}
  return (
    <div
      onClick={props.onClick !== undefined ? props.onClick : null}
      onMouseEnter={props.onMouseEnter !== undefined ? props.onMouseEnter : null}
      onMouseLeave={props.onMouseLeave !== undefined ? props.onMouseLeave : null}
      ref={props.ref !== undefined ? props.ref : null}
      className={
        props.wrapperClass === undefined
        ? (props.hideReserveCard ? "" : "reserve-card")
          : (props.hideReserveCard ? props.wrapperClass : "reserve-card " + props.wrapperClass)
      }   

      id={props.id !== undefined ? props.id : null}
      style={divStyle}   
    >
      <>
     { props.wrapperHeading &&  <h3 className={props.wrapperHeadingClass}>{props.wrapperHeading}</h3>}
        <div className="wrapChild">{props.children}</div>
      </>
    </div>
  );
}

export default CardWrapper;
